/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PlanResponseFeatures } from './planResponseFeatures';

export interface PlanResponse {
  id: string;
  slug: string;
  name: string;
  is_custom?: boolean;
  max_seats: number | null;
  price_monthly_cents: number | null;
  price_annual_cents: number | null;
  credits_per_seat: number;
  mailboxes_per_seat: number;
  linkedin_per_seat: number;
  features: PlanResponseFeatures;
}
